import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import beGetClientSmsText from 'actions/sms/beGetClientSmsText.action';
import SalonFlag from 'components/core/SalonFlag.component';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import SMS_BUNDLE from 'constants/payment/smsBundle.constant';
import SF from 'constants/salonFlag.const';
import useAef from 'hooks/useAef.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import asObject from 'utils/objects/asObject.util';

import CN from './SmsBundle.module.scss';

const BUNDLE_ONE_HUNDRED = 100;
const BUNDLE_FIVE_HUNDRED = 500;
const BUNDLE_TWO_THOUSAND = 2000;

const SmsBundle = ({ beGetClientSmsText, children }) => {
  const salonId = useCurrentSalonId();
  const { t } = useTranslation();

  const smsInfoResult = useAef(async () => (await beGetClientSmsText({ salonId })).json, [beGetClientSmsText, salonId]);
  const smsBundleValue = asObject(asObject(smsInfoResult).value);

  const value = smsBundleValue.auto_top_up_sms_bundle;

  const renderBundle = (displayValue, price) => (
    <div className={CN.flex}>
      {displayValue}
      <Space>{children}</Space>
      <Space>
        <CurrencySign />
        {price} {t('composite.smsBundle.plusTax')}
      </Space>
    </div>
  );

  return (
    <div data-bem="SmsBundle" className={CN.component}>
      <SalonFlag name={SF.smsPricing}>
        <SalonFlag.IfDisabled>
          {value === SMS_BUNDLE.oneHundred && renderBundle(BUNDLE_ONE_HUNDRED, 7)}
          {value === SMS_BUNDLE.fiveHundreds && renderBundle(BUNDLE_FIVE_HUNDRED, 35)}
          {value === SMS_BUNDLE.twoThousands && renderBundle(BUNDLE_TWO_THOUSAND, 126)}
        </SalonFlag.IfDisabled>
        <SalonFlag.IfEnabled>
          {value === SMS_BUNDLE.oneHundred && renderBundle(BUNDLE_ONE_HUNDRED, 6)}
          {value === SMS_BUNDLE.fiveHundreds && renderBundle(BUNDLE_FIVE_HUNDRED, 30)}
          {value === SMS_BUNDLE.twoThousands && renderBundle(BUNDLE_TWO_THOUSAND, 108)}
        </SalonFlag.IfEnabled>
      </SalonFlag>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ beGetClientSmsText }, dispatch);

const SmsBundleHoc = connect(null, mapDispatchToProps)(SmsBundle);

export default SmsBundleHoc;
